import { c as _c } from "react/compiler-runtime";
import { ClientOnly } from '@ark-ui/react/client-only';
import { cva, cx } from '@repo/panda/css';
import type React from 'react';
import type { HTMLAttributes, Ref } from 'react';
import { ScrollableContentClient } from './scrollable-content-client';
const scrollableContentStyles = cva({
  base: {
    position: 'relative',
    width: 'full'
  }
});
const scrollAreaStyles = cva({
  base: {
    overflowY: 'auto',
    width: 'full',
    position: 'relative'
  }
});
export interface ScrollableContentProps extends HTMLAttributes<HTMLDivElement> {
  maxHeight?: string | number;
  children: React.ReactNode;
  scrollAreaProps?: HTMLAttributes<HTMLDivElement>;
  scrollAreaRef?: Ref<HTMLDivElement>;
  scrollAreaStyle?: React.CSSProperties;
  hideScrollbarWhenNoOverflow?: boolean;
  /** Optional border radius applied to the scroll fade indicators (e.g. '12px'). */
  fadeRadius?: string;
}
export const ScrollableContent: React.FC<ScrollableContentProps> = t0 => {
  const $ = _c(46);
  let children;
  let className;
  let fadeRadius;
  let maxHeight;
  let props;
  let scrollAreaProps;
  let scrollAreaRef;
  let scrollAreaStyle;
  let style;
  let t1;
  if ($[0] !== t0) {
    ({
      maxHeight,
      children,
      className,
      style,
      hideScrollbarWhenNoOverflow: t1,
      fadeRadius,
      scrollAreaProps,
      scrollAreaRef,
      scrollAreaStyle,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = fadeRadius;
    $[4] = maxHeight;
    $[5] = props;
    $[6] = scrollAreaProps;
    $[7] = scrollAreaRef;
    $[8] = scrollAreaStyle;
    $[9] = style;
    $[10] = t1;
  } else {
    children = $[1];
    className = $[2];
    fadeRadius = $[3];
    maxHeight = $[4];
    props = $[5];
    scrollAreaProps = $[6];
    scrollAreaRef = $[7];
    scrollAreaStyle = $[8];
    style = $[9];
    t1 = $[10];
  }
  const hideScrollbarWhenNoOverflow = t1 === undefined ? false : t1;
  const resolvedMaxHeight = typeof maxHeight === "number" ? `${maxHeight}px` : maxHeight;
  let t2;
  if ($[11] !== className) {
    t2 = cx(scrollableContentStyles(), className);
    $[11] = className;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  let t3;
  if ($[13] !== scrollAreaProps?.className) {
    t3 = cx(scrollAreaStyles(), scrollAreaProps?.className);
    $[13] = scrollAreaProps?.className;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  let t4;
  if ($[15] !== scrollAreaStyle) {
    t4 = scrollAreaStyle || {};
    $[15] = scrollAreaStyle;
    $[16] = t4;
  } else {
    t4 = $[16];
  }
  const t5 = scrollAreaProps?.style;
  let t6;
  if ($[17] !== resolvedMaxHeight || $[18] !== t4 || $[19] !== t5) {
    t6 = {
      maxHeight: resolvedMaxHeight,
      ...t4,
      ...t5
    };
    $[17] = resolvedMaxHeight;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
  } else {
    t6 = $[20];
  }
  let t7;
  if ($[21] !== children || $[22] !== scrollAreaProps || $[23] !== scrollAreaRef || $[24] !== t3 || $[25] !== t6) {
    t7 = <div {...scrollAreaProps} ref={scrollAreaRef} className={t3} style={t6}>{children}</div>;
    $[21] = children;
    $[22] = scrollAreaProps;
    $[23] = scrollAreaRef;
    $[24] = t3;
    $[25] = t6;
    $[26] = t7;
  } else {
    t7 = $[26];
  }
  let t8;
  if ($[27] !== props || $[28] !== style || $[29] !== t2 || $[30] !== t7) {
    t8 = <div className={t2} style={style} {...props}>{t7}</div>;
    $[27] = props;
    $[28] = style;
    $[29] = t2;
    $[30] = t7;
    $[31] = t8;
  } else {
    t8 = $[31];
  }
  const fallback = t8;
  let t9;
  if ($[32] !== children || $[33] !== className || $[34] !== fadeRadius || $[35] !== hideScrollbarWhenNoOverflow || $[36] !== maxHeight || $[37] !== props || $[38] !== scrollAreaProps || $[39] !== scrollAreaRef || $[40] !== scrollAreaStyle || $[41] !== style) {
    t9 = <ScrollableContentClient maxHeight={maxHeight} className={className} style={style} hideScrollbarWhenNoOverflow={hideScrollbarWhenNoOverflow} fadeRadius={fadeRadius} scrollAreaProps={scrollAreaProps} scrollAreaRef={scrollAreaRef} scrollAreaStyle={scrollAreaStyle} {...props}>{children}</ScrollableContentClient>;
    $[32] = children;
    $[33] = className;
    $[34] = fadeRadius;
    $[35] = hideScrollbarWhenNoOverflow;
    $[36] = maxHeight;
    $[37] = props;
    $[38] = scrollAreaProps;
    $[39] = scrollAreaRef;
    $[40] = scrollAreaStyle;
    $[41] = style;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] !== fallback || $[44] !== t9) {
    t10 = <ClientOnly fallback={fallback}>{t9}</ClientOnly>;
    $[43] = fallback;
    $[44] = t9;
    $[45] = t10;
  } else {
    t10 = $[45];
  }
  return t10;
};